// extracted by mini-css-extract-plugin
export var chevron = "_lx-4";
export var chevronExpanded = "_lx-5";
export var row = "_lx-0";
export var rowBody = "_lx-6";
export var rowDescription = "_lx-7";
export var rowHeader = "_lx-1";
export var rowTitle = "_lx-2";
export var rowTitleComplete = "_lx-3";